import { render, staticRenderFns } from "./senders_live.vue?vue&type=template&id=7b25fb9a&"
import script from "./senders_live.vue?vue&type=script&lang=js&"
export * from "./senders_live.vue?vue&type=script&lang=js&"
import style0 from "./senders_live.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports